<div class="section-home">
    <div class="welcome">
        <img src="../../assets/images/Skip Full Logo - Transparent.png" alt="logo">
        <h1>Welcome to AskSkip!</h1>
        <div class="welcome-buttons">
            <button class="btn" (click)="doLogin()">Log In</button>
            <button class="btn btn--outline" (click)="doSignUp()">Sign Up</button>
        </div>
    </div>
</div>
